import {IconButton, Stack} from "@mui/material";
import {useTranslation} from "react-i18next";
import {AgGridReact} from "ag-grid-react";
import { useMemo, useRef } from "react";
import {ColDef, ICellRendererParams, SideBarDef} from "ag-grid-community";
import {DescriptionRounded} from "@mui/icons-material";
import {Link} from "react-router-dom";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";

import {useHasScope} from "../../../../config/globalConfig";
import { NetworkScope } from "../../types";

const ContractorTable = ({serverSideDatasource}: any) => {
    const {t, i18n} = useTranslation(['network', 'translation']);
    const hasScope = useHasScope;

    const sideBar = useMemo<SideBarDef>(() => ({
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
                toolPanelParams: {
                    suppressRowGroups: true,
                    suppressValues: true,
                    suppressPivots: true,
                    suppressPivotMode: true,
                    suppressColumnExpandAll: true,
                },
            },
        ],
        defaultToolPanel: '',
    }), []);

    const gridRef = useRef<AgGridReact>(null);
    const columnDefs = useMemo<ColDef[]>(() => [
        {
            field: 'id',
            headerName: "",
            width: 70,
            resizable: false,
            suppressMovable: true,
            suppressSizeToFit: false,
            suppressColumnsToolPanel: true,
            pinned: 'right',
            cellRenderer: (params: ICellRendererParams) => {
                const url = `/network/contractor-mng/${params.data?.id}`
                return (
                    hasScope( NetworkScope.MsDetail) &&
                    <Stack direction={"row"} justifyContent={"center"}>
                        <Link to={url} target="_blank">
                            <IconButton color="accent">
                                <DescriptionRounded />
                            </IconButton>
                        </Link>
                    </Stack>
                );
            }
        },
        {field: 'companyName', headerName: t("contractorMng.openRoyalityFeesManagement.grid.companyName"), sortable: true},
        {field: 'bpCode', headerName: t("contractorMng.openRoyalityFeesManagement.grid.bpCode"), sortable: true},
        {field: 'icaoCode', headerName: t("contractorMng.openRoyalityFeesManagement.grid.icaoCode"), sortable: true},
        {field: 'iataCode', headerName: t("contractorMng.openRoyalityFeesManagement.grid.iataCode"), sortable: true},
        {field: 'type', headerName: t("contractorMng.openRoyalityFeesManagement.grid.type"), sortable: true, cellRenderer: (params: { value: any }) => {
            const label = params.value.split('|')[1];
            return t(`contractorMng.openRoyalityFeesManagement.form.labels.typeValues.${label}`, { defaultValue: label });
          }},
        {field: 'currentStatus', headerName: t("contractorMng.openRoyalityFeesManagement.grid.currentStatus"), sortable: true},
        {field: 'country', headerName: t("contractorMng.openRoyalityFeesManagement.grid.country"), sortable: true},
        {field: 'province', headerName: t("contractorMng.openRoyalityFeesManagement.grid.province"), sortable: true},
        {field: 'region', headerName: t("contractorMng.openRoyalityFeesManagement.grid.region"), sortable: true},
        {field: 'city', headerName: t("contractorMng.openRoyalityFeesManagement.grid.city"), sortable: true},
        {field: 'vatNumber', headerName: t("contractorMng.openRoyalityFeesManagement.grid.vatNumber"), sortable: true},
        {field: 'siren', headerName: t("contractorMng.openRoyalityFeesManagement.grid.siren"), sortable: true},
        {field: 'siret', headerName: t("contractorMng.openRoyalityFeesManagement.grid.siret"), sortable: true},
        {field: 'fiscalCode', headerName: t("contractorMng.openRoyalityFeesManagement.grid.fiscalCode"), sortable: true},
        {
            headerName: t('searchDms.form.label.certificationProtocolId'),
            field: 'eParking.certificationProtocolIdentifyingCode'
        },
    ], [i18n.language] );

    return (
        <AgGridCustomTable
            gridRef={gridRef}
            rowModelType='serverSide'
            serverSideInfiniteScroll
            serverSideDatasource={serverSideDatasource}
            columnDefs={columnDefs}
            gridOptions={
                {
                    defaultColDef: { lockPinned: true, resizable: true, suppressSizeToFit: true },
                    onGridReady: (event) => {
                        event.api.sizeColumnsToFit()
                    }
                }
            }
            sideBar={sideBar}
        />
    )
}

export default ContractorTable;
